import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import bookingApi from '@/features/public/booking/api/bookingApi.ts';
import { bookingApiQueryKeys } from '@/features/public/booking/api/bookingApi.queryKeys.ts';
import CustomFieldDefinitionDto from '@/features/dashboard/tourCustomFields/types/_CustomFieldDefinitionDto.ts';

const useGetParticipantForm = (orgSlug: string, tourSlug: string) => {
  return useQuery(getParticipantFormQueryOptions(orgSlug, tourSlug));
};

export const getParticipantFormQueryOptions = (
  orgSlug: string,
  tourSlug: string,
): UseQueryOptions<CustomFieldDefinitionDto[]> => ({
  queryKey: bookingApiQueryKeys.participantForm(orgSlug, tourSlug),
  queryFn: async () => {
    const fields = await bookingApi.getParticipantForm(orgSlug, tourSlug);
    return [...fields].sort((a, b) => a.orderIndex - b.orderIndex);
  },
  staleTime: 1000 * 60 * 15,
  gcTime: 1000 * 60 * 15,
  retry: 1,
});

export default useGetParticipantForm;
